import * as queries from './queries';

export const countries = {
  queries: {
    ...queries
  }
};
